/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RoutePath } from 'shared/enums/RoutePath';
import useOrganization from '../../../../organization/useOrganization';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { selectRoles, selectStatus, updateUserRoles } from './user.edit.role.slice';
import { editUserRoles } from './user.edit.role.thunk';
import history from '../../../../history';

// !!!!REFACTOR NEEDED
export default function useEditUserRole(userId, user) {
  const [isLoading, setIsLoading] = useState(false);
  const [editRole, setEditRole] = useState(false);
  const [currentOrganizationId, setCurrentOrganizationId] = useState();
  const [disabled, setDisabled] = useState(false);
  const [pagingSortingAndFiltering, setPagingSortingAndFiltering] = useState({});

  const currentOrganization = useOrganization();
  const dispatch = useDispatch();
  const userRoles = useSelector(selectRoles);
  const status = useSelector(selectStatus);
  const onUpdateUserRoles = (newRoles) => {
    dispatch(updateUserRoles(newRoles));
  };

  useEffect(() => {
    setPagingSortingAndFiltering(undefined);
  }, [pagingSortingAndFiltering]);

  useEffect(() => {
    if (user) {
      const currentOrgId = currentOrganization?.id;
      const userRolesArray = user.groups?.find(group => group.id === currentOrgId)?.roles;
      const userRolesInOrg = userRolesArray?.map(role => role);
      onUpdateUserRoles(userRolesInOrg);
      setCurrentOrganizationId(currentOrgId);
    }
  }, [user, userId]);

  const onRoleChange = (role) => {
    let roles = [];
    if (userRoles) {
      roles = [...userRoles];
    }
    const indexOfRole = roles.findIndex(value => value === role);
    if (indexOfRole > -1) {
      roles.splice(indexOfRole, 1);
    } else {
      roles.push(role);
    }
    setDisabled(roles.length === 0);
    onUpdateUserRoles(roles);
  };

  const handleEditRoles = () => {
    setEditRole(!editRole);
  };

  useEffect(() => {
    setIsLoading(status === ThunkStatus.LOADING);
  }, [status]);

  const onSubmit = (organization) => {
    dispatch(
      editUserRoles({
        organizationId: currentOrganizationId,
        userId,
        userRoles,
      }),
    );
    if (history && organization)
      history.push(
        RoutePath.generateRoutePath(RoutePath.USER_SEARCH, {
          organization: currentOrganizationId,
        }),
      );
  };

  return {
    userRoles,
    isLoading,
    onSubmit,
    onUpdateUserRoles,
    onRoleChange,
    handleEditRoles,
    editRole,
    currentOrganizationId,
    disabled,
  };
}
